import { render, staticRenderFns } from "./RolePermissionsList.vue?vue&type=template&id=44178e9e&scoped=true"
import script from "./RolePermissionsList.vue?vue&type=script&lang=ts"
export * from "./RolePermissionsList.vue?vue&type=script&lang=ts"
import style0 from "./RolePermissionsList.vue?vue&type=style&index=0&id=44178e9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44178e9e",
  null
  
)

export default component.exports